/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots9Icon16Regular = forwardRef('UiMenuDots9Icon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M13 4.246a1.248 1.248 0 1 0 0-2.496 1.248 1.248 0 0 0 0 2.496Z" }),
        React.createElement("path", { d: "M14.248 8a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M3 14.25a1.248 1.248 0 1 0 0-2.497 1.248 1.248 0 0 0 0 2.497Z" }),
        React.createElement("path", { d: "M9.248 13.002a1.248 1.248 0 1 1-2.497 0 1.248 1.248 0 0 1 2.497 0Z" }),
        React.createElement("path", { d: "M14.248 13.002a1.248 1.248 0 1 1-2.497 0 1.248 1.248 0 0 1 2.497 0Z" }),
        React.createElement("path", { d: "M8 9.248a1.248 1.248 0 1 0 0-2.497 1.248 1.248 0 0 0 0 2.497Z" }),
        React.createElement("path", { d: "M4.248 8a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M9.248 2.998a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M3 4.246A1.248 1.248 0 1 0 3 1.75a1.248 1.248 0 0 0 0 2.496Z" })));
});
